import {
    Flex,
    Text,
    Image,
    Heading,
    Button
} from '@chakra-ui/react';
import {
    CheckCircleIcon
} from '@chakra-ui/icons'


const StoreCard = (overrideStyles) => {
    return (
        <Flex
            bg={'gray.100'}
            flexDirection={{
                base: 'row',
                md: 'column',
            }}
            zIndex={1}
            position={'relative'}
            shadow={'md'}
            cursor={'pointer'}
            p={4}
            {...overrideStyles}
        >
            <Flex flex={1}>
                <Image 
                    src={'/images/alexa.jpg'}
                    alt={'Airpods'}
                    objectFit={'contain'}
                    w={'100%'}
                    maxH='100%'
                    borderRadius={'md'}
                />
            </Flex>
            <Flex flex={1}
                pl={{
                    base: 4,
                    md: 0,
                }}
                justifyContent='space-between'
                alignItems='center'
            >
                <Flex 
                    flexDir={{
                        base: 'column',
                        md: 'column',
                    }}
                    h='100%'
                    justifyContent='space-between'
                >
                    <Flex flexDir='column'>
                        <Heading as="h1" size="md" mt={3}>
                            Coffee Solutions
                        </Heading>
                        <Text mt={2} mb={3} fontSize='sm' >
                            Compra tus productos favoritos del mundo del café.
                        </Text>
                    </Flex>
                    <Button size='sm' colorScheme='blue' >
                        Ver Productos
                    </Button>
                </Flex>
            </Flex>
        </Flex>
    )
}

export default StoreCard;